"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

/**
 * A class to represent the the options that are passed to the MwChartDonutChartOptions.onPointClick
 * @param {object} options - See below
 * @param {object} options.point - The 'Point' object from Highcharts
 *
 * @property {number} percentage - The percentage of the slice
 * @property {number} sliceIndex - The position of the slice
 * @property {string} sliceName - The name of the slice
 * @property {number} value - The value of the slice
 *
 */
var MwChartDonutClickOptions = function MwChartDonutClickOptions(_ref) {
  var point = _ref.point;
  (0, _classCallCheck2.default)(this, MwChartDonutClickOptions);
  this.percentage = point.percentage;
  this.sliceIndex = point.index;
  this.sliceName = point.name;
  this.value = point.y;
  Object.freeze(this);
};

exports.default = MwChartDonutClickOptions;